import { clsx } from 'clsx';

export function ExternalLinkIcon({ className }: { className?: string }) {
  return (
    <svg className={clsx('w-3 h-3 shrink-0', className)} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
    </svg>
  );
}
